/** * プレイスコンポーネント */
<template>
  <b-container id="the-place" class="container-place">
    <!-- 検索ツールバー -->
    <div class="tool-bar">
      <b-form-row class="tool-bar-form">
        <!-- プレイスグループ選択 -->
        <b-col class="place-group-select-col">
          <place-group-selector
            v-bind:onApiError="handleApiError"
            v-on:place-group-change="$_changePlaceGroup"
          ></place-group-selector>
        </b-col>
        <!-- ユーザ選択 -->
        <b-col class="user-select-col">
          <user-selector
            v-bind:defaultText="$t('thePlace.allUsers')"
            v-bind:keywordTarget="
              $store.getters['userKeywordTarget/keywordTargets']
            "
            v-bind:onApiError="handleApiError"
            v-bind:allOrganizations="true"
            v-bind:primaryOrganizationId="
              $store.getters['userProfile/defaultOrganizationId']
            "
            v-bind:indoorSites="$store.getters['indoorSite/indoorSites']"
            v-on:change:value="$_fixSelectedUsers"
            v-on:change:keywordTarget="
              $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
            "
          ></user-selector>
        </b-col>
        <!-- 検索期間 -->
        <b-col class="datetime-select-col">
          <datetime-selector
            v-bind:fieldLabel="$t('thePlace.registrationDate')"
            v-bind:periodString="null"
            v-bind:periodFlg="true"
            v-on:datetime-selectend="$_changeSearchPeriod"
          ></datetime-selector>
        </b-col>
        <!-- キーワード検索 -->
        <b-col>
          <input-keyword-place
            inline
            v-model="localKeyword"
            v-bind:id-prefix="'place-keyword-target'"
            v-bind:placeholder="$t('thePlace.placeholder.searchKeyword')"
            v-bind:keyword-targets="keywordTargets"
            v-on:keyword-changed="$_changeKeyword"
            v-on:keyword-target-changed="$_fixSelectedKeywordTarget"
          />
        </b-col>
      </b-form-row>
    </div>
    <b-row no-gutters class="content-wrapper">
      <!-- プレイス一覧 -->
      <b-col cols="4" class="view-list" v-show="isListViewShown">
        <!-- タイトルバー -->
        <b-row class="title-bar">
          <b-col class="title-bar-between title-bar-list">
            <!-- プレイス件数 -->
            <h1>
              {{ $tc('thePlace.numberOfPlaces', placeTotalCount) }}
            </h1>
            <div class="title-bar-action">
              <!-- 更新 -->
              <div class="title-bar-reload">
                <div class="label" v-show="listUpdatedDateLabel">
                  {{ $t('thePlace.listUpdate.field') }} :
                  {{ listUpdatedDateLabel }}
                </div>
                <button-reload v-on:click="$_onClickReload" />
              </div>
              <!-- 作成ボタン -->
              <b-button
                variant="light"
                v-ifield-b-tooltip.hover
                v-bind:title="$t('thePlace.action.createPlace')"
                class="button-create"
                v-on:click="createPlace"
              >
                <icon-place class="icon" />
                <span v-t="'thePlace.action.create'" />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!-- プレイス一覧 -->
        <div class="list-wrapper">
          <loading-mask v-bind:isLoading="isLoading">
            <!-- プレイスのヘッダー -->
            <div class="list-header">
              <filter-button-group
                v-model="currentPositionFixTypes"
                v-bind:buttons="positionFixFilterButtons"
                v-bind:label="$t('thePlace.display')"
              />
            </div>
            <recycle-scroller
              class="list-inner"
              ref="place-list-inner"
              v-bind:items="places"
              v-bind:item-size="180"
              v-slot="{ item }"
            >
              <div class="place-detail-content">
                <card-place
                  v-bind:id="item.id"
                  v-bind:placeName="item.place_name"
                  v-bind:placeAddress="item.address1"
                  v-bind:attachFilesCount="
                    $_getAttachFileCount(item.place_attach_files)
                  "
                  v-bind:placeGroupNames="
                    $_getPlaceGroupNames(item.place_groups)
                  "
                  v-bind:placeUserRelationNames="
                    $_getUserRelationNames(item.place_user_relations)
                  "
                  v-bind:placeOrganizationRelationNames="
                    $_getOrganizationRelationNames(
                      item.place_organization_relations
                    )
                  "
                  v-bind:is-fixed-position="item.position_fix_flg"
                  v-on:placecard-click="$_onClickCardBody"
                  v-on:placecard-title-click="$_onClickCardTitle"
                  v-on:placecard-detail-click="$_onClickCardDetail"
                />
              </div>
            </recycle-scroller>
            <!-- 一覧フッター -->
            <b-row class="list-footer">
              <!-- ページネーション -->
              <b-col cols="12">
                <b-pagination
                  ref="pagination"
                  v-model="currentPlacePage"
                  v-bind:total-rows="placeTotalCount"
                  v-bind:per-page="placeLimit"
                  align="center"
                  size="sm"
                  class="place-pagination"
                ></b-pagination>
              </b-col>
            </b-row>
          </loading-mask>
        </div>
      </b-col>
      <!-- 地図 -->
      <b-col v-bind:cols="viewCols.right" class="view-map">
        <map-control
          ref="map-control"
          id="place-map-control"
          v-bind="$store.getters.mapControlBinds"
          v-bind:id-prefix="'place-'"
          v-bind:layer-renderers="layerRenderers"
          v-bind:reactive-render="!isModalOverlaid"
          v-bind:onIfieldApiError="handleApiError"
          v-on:indoor-level-selected="setActiveIndoorLevelId"
          v-on:map-control-initend="$_onMapInitEnd"
          v-on:deck-overlay-initend="$_onDeckInitEnd"
          v-on:map-control-bounds-changed="$_onBoundsChanged"
          v-on:menu-layers-visible-changed="
            $store.dispatch('map/setVisible', $event)
          "
        >
          <template v-slot:map-left-top>
            <!-- ビル表示ボタン -->
            <map-indoor-building-button
              v-bind:indoor-building="
                $store.getters['mapIndoor/activeIndoorBuilding']
              "
              class="map-control-ui"
              v-on:reset-click="unselectedBuilding"
            />
            <!-- リスト切り替えタブ -->
            <list-view-toggle-tab
              v-model="isListViewShown"
              v-bind:listViewCols="viewCols.left"
              v-bind:idPrefix="'place'"
              class="map-control-ui list-tab"
              v-on:listview-toggletab-toggled="$_toggleListViewShown"
            />
          </template>
        </map-control>
      </b-col>
    </b-row>
    <map-layer-controller
      v-bind:layer-render-parameters="layerRenderParameters"
      v-on:map-layer-renderers-created="$_onMapLayerRenderersCreated"
    />
    <place-detail
      ref="place-detail"
      v-on:place-searchreport-click="$_showReport"
      v-on:place-searchuser-click="$_showMember"
      v-on:hide-modal="$_onHideDetailDialog"
    />
    <place-editor
      ref="place-editor"
      v-bind:idPrefix="'new'"
      v-on:place-editend="$_onCreatedPlace"
    />
    <!-- モーダル重畳検知 -->
    <modal-overlay-detector
      v-on:is-modal-overlaid-changed="$_onModalOverlayChanged"
    />
  </b-container>
</template>

<script>
import InputKeywordPlace from '@/components/AppInputKeywordPlace.vue'
import ButtonReload from '@/components/AppButtonReload.vue'
import FilterButtonGroup from '@/components/AppFilterButtonGroup.vue'
import CardPlace from '@/components/place/AppCardPlace.vue'
import PlaceDetail from '@/views/ThePlaceDetail.vue'
import PlaceEditor from '@/views/ThePlaceEditor.vue'
import BvModalOverlayDetector from '@/components/AppBvModalOverlayDetector.vue'
import ListViewToggleTab from '@/components/AppListViewToggleTab.vue'
import MapLayerController from '@/components/map/AppMapLayerController.vue'
import { MapIndoorBuildingButton } from 'ifield-core-components'
import { RestApiClient } from 'ifield-core-components'
import Bounds from '@/model/geo/Bounds.js'
import GeometryUtil from '@/js/util/GeometryUtil.js'
import { toServerTz } from '@/js/TimezoneHelper'
import {
  NULL_STRING_API,
  DATE_FORMAT_HYPHEN,
  TIME_FORMAT_MILLISECOND,
} from '@/constants.js'
import { mapGetters } from 'vuex'
import IconPlace from '@/assets/ifield/ic_place.svg?component'

import _ from 'lodash'
import moment from 'moment'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'
import { useMapLayerFilter } from '@/composables/map/UseMapLayerFilter'
import { useMapIndoorStore } from '@/composables/map/UseMapIndoorStore'
import ModalUtil from '@/js/util/ModalUtil.js'

/**
 * 検索対象の位置確定種別(定数)
 */
const POSITION_FIX_TYPES = {
  ALL: 'all',
  UNFIXED: 'unfixed',
  FIXED: 'fixed',
}

/**
 * ミリ秒日時フォーマット
 */
const DATETIME_FORMAT_MILLISECOND = `${DATE_FORMAT_HYPHEN}T${TIME_FORMAT_MILLISECOND}`

export default {
  name: 'ThePlace',
  components: {
    'input-keyword-place': InputKeywordPlace,
    'button-reload': ButtonReload,
    'icon-place': IconPlace,
    'filter-button-group': FilterButtonGroup,
    'card-place': CardPlace,
    'place-detail': PlaceDetail,
    'place-editor': PlaceEditor,
    'map-indoor-building-button': MapIndoorBuildingButton,
    'list-view-toggle-tab': ListViewToggleTab,
    'recycle-scroller': RecycleScroller,
    'map-layer-controller': MapLayerController,
    'modal-overlay-detector': BvModalOverlayDetector,
  },
  filters: {},
  props: {
    /** プレイス一覧の1ページあたりの表示件数 */
    placeLimit: {
      type: Number,
      default: 10,
    },
  },
  setup() {
    const { handleApiError } = useHandleApiError()
    const { targetIds, updateTargetIds, layerRenderParameters } =
      useMapLayerFilter()
    const { unselectedBuilding, setActiveIndoorLevelId } = useMapIndoorStore()
    return {
      handleApiError,
      targetIds,
      updateTargetIds,
      layerRenderParameters,
      unselectedBuilding,
      setActiveIndoorLevelId,
    }
  },
  data: function () {
    return {
      /**
       * ページが表示されている場合はtrue
       * keep-alive で保持されるため、非表示でも破棄されない
       * @type {Boolean}
       */
      isViewActive: true,
      /**
       * プレイスデータ
       * @type {Array.<Object>}
       */
      places: [],
      /**
       * 現在の条件下の総プレイス件数
       * @type {Number}
       */
      placeTotalCount: 0,
      /**
       * 地図表示範囲
       * @type {Object}
       */
      bounds: null,
      /**
       * 選択中のプレイスグループID
       * @type {number}
       */
      currentPlaceGroupId: null,
      /**
       * 選択中のユーザーID
       */
      currentUserIds: [],
      /**
       * 選択中のグループID
       */
      currentOrganizationIds: [],
      /**
       * 検索キーワード
       * @type {string}
       */
      searchKeyword: null,
      /**
       * 内部用キーワード(リアクティブ化を避けるため分離）
       * @type {string}
       */
      localKeyword: null,
      /**
       * 現在選択している検索対象の位置確定状態
       */
      currentPositionFixTypes: POSITION_FIX_TYPES.ALL,
      /**
       * 現在選択している検索期間
       */
      searchPeriod: {
        /** 開始日 */
        startDate: null,
        /** 終了日 */
        endDate: null,
      },
      /**
       * 現在選択しているプレイス一覧のページ番号
       * @type {number}
       */
      currentPlacePage: 1,
      /**
       * レイヤーレンダラー
       * @type {Array.<Object>}
       */
      layerRenderers: [],
      /**
       * リストビューを表示する場合true
       * @type {Boolean}
       */
      isListViewShown: true,
      /**
       * 一覧表示の最終更新日時
       * @type {Date}
       */
      listUpdatedDate: null,
      /**
       * ロード中の場合はtrue
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * モーダルが重畳している場合はtrue
       * @type {Boolean}
       */
      isModalOverlaid: false,
    }
  },
  computed: {
    ...mapGetters('map', ['zoom']),
    ...mapGetters('mapLayer', ['clickedPlace']),
    ...mapGetters('mapIndoor', ['activeIndoorLevelId', 'isGlobalMode']),
    ...mapGetters('place', ['keywordTargets']),
    /**
     * 位置確定状態絞り込みボタン
     * @type {Array.<Object>}
     */
    positionFixFilterButtons: function () {
      return [
        { value: POSITION_FIX_TYPES.ALL, text: this.$t('thePlace.filter.all') },
        {
          value: POSITION_FIX_TYPES.UNFIXED,
          text: this.$t('thePlace.filter.unfixed'),
        },
        {
          value: POSITION_FIX_TYPES.FIXED,
          text: this.$t('thePlace.filter.fixed'),
        },
      ]
    },
    /**
     * 現在選択している検索対象の位置確定種別が「すべて」の場合にtrueを返却する
     */
    isSelectedFixTypeAll: function () {
      return this.currentPositionFixTypes === POSITION_FIX_TYPES.ALL
    },
    /**
     * 現在選択している検索対象の位置確定種別が「位置未確定」の場合にtrueを返却する
     */
    isSelectedFixTypeUnfixed: function () {
      return this.currentPositionFixTypes === POSITION_FIX_TYPES.UNFIXED
    },
    /**
     * 現在選択している検索対象の位置確定種別が「位置確定済み」の場合にtrueを返却する
     */
    isSelectedFixTypeFixed: function () {
      return this.currentPositionFixTypes === POSITION_FIX_TYPES.FIXED
    },
    /**
     * 地図表示範囲(Boundsのインスタンス)
     * @type {Bounds}
     */
    mapBounds: function () {
      return new Bounds(this.bounds)
    },
    /**
     * fitBounds時に指定するズームレベル
     * @type {Number}
     */
    zoomOnFitBounds: function () {
      // 屋内時はデフォルトで20まで寄る
      const defaultZoom = this.isGlobalMode ? 18 : 20
      return Math.max(defaultZoom, this.zoom)
    },
    /**
     * 検索条件が全く指定されていない場合にtrueを返却する
     * @type {Boolean}
     */
    isSearchParamsEmpty: function () {
      return (
        this.currentPlaceGroupId == null &&
        this.currentUserIds.length === 0 &&
        this.currentOrganizationIds.length === 0 &&
        Object.values(this.searchPeriod).every((value) => value == null) &&
        (this.searchKeyword == null || this.searchKeyword === '') && // フォームを空にすると空文字を返すことへの対応
        this.isSelectedFixTypeAll
      )
    },
    /**
     * 位置確定フラグのAPI用パラメータ値
     * @type {Number}
     */
    positionFixFlgParamValue: function () {
      if (this.isSelectedFixTypeFixed) {
        return 1
      } else if (this.isSelectedFixTypeUnfixed) {
        return 0
      }
      return null
    },
    /**
     * 表示範囲内のプレイスのみ表示する場合はtrue
     * - 検索条件が設定されていない
     * - 屋外
     * @type {Boolean}
     */
    toShowPlacesOnlyInBounds: function () {
      return this.isSearchParamsEmpty && !this.activeIndoorLevelId
    },
    /**
     * API取得用パラメータ
     */
    paramsForApi: function () {
      const params = {}

      // プレイスグループ
      if (this.currentPlaceGroupId) {
        params.place_group_id = this.currentPlaceGroupId
      }
      // ユーザーID
      if (this.currentUserIds.length > 0) {
        params.extend_user_id = this.currentUserIds
      }
      // グループID
      if (this.currentOrganizationIds.length > 0) {
        params.organization_id = this.currentOrganizationIds
      }
      // 検索期間
      const startDate = this.$_createMoment(this.searchPeriod.startDate)
      if (startDate && startDate.isValid()) {
        startDate.set({
          'hour': 0,
          'minute': 0,
          'second': 0,
          'millisecond': 0,
        })
        params.from = toServerTz(+startDate, DATETIME_FORMAT_MILLISECOND)
      }
      const endDate = this.$_createMoment(this.searchPeriod.endDate)
      if (endDate && endDate.isValid()) {
        endDate.set({
          'hour': 23,
          'minute': 59,
          'second': 59,
          'millisecond': 999,
        })
        params.to = toServerTz(+endDate, DATETIME_FORMAT_MILLISECOND)
      }
      // キーワード
      if (this.searchKeyword) {
        // 半角スペース区切りでor検索ができるため、全角スペースを半角スペースに置き換える
        let keyword = this.searchKeyword.replace(/　/g, ' ')
        params.keyword = keyword
        // 検索項目パラメータ追加
        if (this.keywordTargets && this.keywordTargets.length) {
          params['keyword_target'] = this.keywordTargets.join(',')
        }
      }
      // 位置確定
      if (this.positionFixFlgParamValue !== null) {
        params.position_fix_flg = this.positionFixFlgParamValue
      }
      // 屋内レベル
      params.indoor_level_id = this.activeIndoorLevelId || NULL_STRING_API
      // 表示範囲
      if (this.toShowPlacesOnlyInBounds) {
        params.bbox = this.mapBounds.toString()
      }

      return params
    },
    /**
     * 現在のページが最終の場合にtrueを返却する
     */
    isLastPage: function () {
      return (
        (this.currentPlacePage - 1) * this.placeLimit < this.placeTotalCount
      )
    },
    /**
     * 現在のページが最大個数表示されている場合にtrueを返却する
     */
    isCurrentPageFull: function () {
      return this.places.length === this.placeLimit
    },
    /**
     * ビュー分割のcol数
     */
    viewCols: function () {
      return this.isListViewShown
        ? { left: 4, right: 8 }
        : { left: 0, right: 12 }
    },
    /**
     * 表示用の一覧の最終更新日
     * @return {string}
     */
    listUpdatedDateLabel: function () {
      if (!this.listUpdatedDate) {
        return ''
      }
      return moment(this.listUpdatedDate).format(
        this.$t('thePlace.listUpdate.format')
      )
    },
  },
  created: function () {
    this.showPlaceDataDebounce = _.debounce(this.showPlaceData, 250)
    this.$_updateIndoorSites()
  },
  mounted: function () {
    this.$_showLoading()
    this.$log.debug('place mounted!')
  },
  activated: function () {
    // 初回描画時は created / mounted で初期化済みなので何もしない
    if (this.isViewActive) return
    this.$log.debug('place activated!')
    this.isViewActive = true
    // 地図は作り直されず map-control-initend も発生しないため、ここで取得し直す
    this.showPlaceData()
  },
  deactivated: function () {
    this.$log.debug('place deactivated!')
    this.isViewActive = false
    // 開いたままのダイアログを閉じる
    ModalUtil.hideAllIn(this)
  },
  watch: {
    currentPlacePage: function () {
      this.showPlaceData()
    },
    currentPositionFixTypes: function () {
      this.showPlaceData()
    },
    activeIndoorLevelId: function () {
      if (!this.isModalOverlaid) {
        this.showPlaceData()
      }
    },
    clickedPlace(value) {
      // Place がクリックされた
      this.$log.debug('[DEBUG] clickedPlace', value)
      // 保持されている非表示のページでも watcher は動くので、表示中のページだけが開く
      if (value && this.isViewActive && !this.isModalOverlaid) {
        const recordId = value.properties.place_id
        this.$_showDialog(recordId)
      }
    },
  },
  methods: {
    /**
     * サイトデータ更新
     */
    $_updateIndoorSites: async function () {
      try {
        this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch indoor sites. use fetched before.')
        })
      }
    },

    /**
     * 地図初期化完了時処理
     */
    $_onMapInitEnd: function () {
      this.map = this.$refs['map-control']
      this.bounds = this.map.getBounds()
      this.showPlaceData()
    },

    /**
     * deckオーバーレイ初期化時処理
     */
    $_onDeckInitEnd: function () {
      this.deck = this.map && this.map.getMapDeckController()
    },

    /**
     * レンダラー作成完了時処理
     * @param {Array.<Object>} renderers 作成されたレンダラー配列
     */
    $_onMapLayerRenderersCreated: function (renderers) {
      this.layerRenderers = renderers.map((r) => r.render)
    },

    /**
     * プレイス一覧を表示する
     */
    showPlaceData: async function () {
      this.$_showLoading()

      // プレイス取得
      const results = await Promise.allSettled([
        this.$_getPlaces(),
        this.$_getPlaceCount(),
        this.$_updatePlaceIdsForMap(),
      ])
      const failedResults = results.filter((r) => r.status === 'rejected')
      if (failedResults.length) {
        failedResults.forEach((r) => this.$log.error(r.reason))
        this.$_hideLoading()
        return
      }

      // 地図範囲に依らない取得でプレイス総件数が1件なら地図をfitする
      if (!this.toShowPlacesOnlyInBounds && this.placeTotalCount === 1) {
        this.$_fitMap(this.places)
      }

      // 一覧のスクロールバーを先頭に戻す
      this.$_moveScrollToTop()
      // 検索条件取得か初期取得の時は更新日時を更新する
      if (!this.isSearchParamsEmpty || !this.listUpdatedDate) {
        this.listUpdatedDate = Date.now()
      }

      this.$_hideLoading()
    },

    /**
     * プレイスデータ取得
     */
    $_getPlaces: async function () {
      const url = RestApiClient.createApiUrl('place')
      const params = url.searchParams
      this.$_addSearchCondition(params)

      // limit, offset
      params.append('limit', this.placeLimit)
      var offset = (this.currentPlacePage - 1) * this.placeLimit
      if (offset >= 1) {
        // offsetに0を設定するとAPIエラーになってしまうため、1以上の場合のみ設定する
        params.append('offset', offset)
      }

      try {
        const json = await RestApiClient.executeGetApi(url)
        this.places = json.data
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    /**
     * プレイス件数取得
     */
    $_getPlaceCount: async function () {
      const url = RestApiClient.createApiUrl('place/count')
      const params = url.searchParams
      this.$_addSearchCondition(params)

      try {
        const json = await RestApiClient.executeGetApi(url)
        this.placeTotalCount = json.data.count
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    /**
     * 地図表示対象対象プレイスIDを更新する
     */
    $_updatePlaceIdsForMap: async function () {
      if (this.toShowPlacesOnlyInBounds) {
        // IDでのfilteringは必要ない
        this.targetIds.place = null
        return
      }
      await this.$_getPlaceIdsForMap()
    },

    /**
     * 地図表示対象対象プレイスID取得
     */
    $_getPlaceIdsForMap: async function () {
      const url = RestApiClient.createApiUrl('place/id')
      const params = url.searchParams
      this.$_addSearchCondition(params)

      try {
        const json = await RestApiClient.executeGetApi(url)
        this.targetIds.place = json.data
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    /**
     * URLSearchParamsに検索パラメータを追加する(limit, offsetは含まない)
     * @param {URLSearchParams} params パラメータを追加するURLSearchParams
     */
    $_addSearchCondition: function (params) {
      for (const [key, value] of Object.entries(this.paramsForApi)) {
        params.append(key, value)
      }
    },

    /**
     * 地図をデータにfitさせる
     * @param {Array.<Object>} data フィット対象データ
     */
    $_fitMap: function (data) {
      const geometries = data.map((place) => place.geom.geometry)
      const bounds = GeometryUtil.getBounds(geometries)
      if (!bounds.isEmpty) {
        this.map.fitBounds(bounds.toObject(), this.zoomOnFitBounds)
      }
    },

    /**
     * スクロールバーをトップに戻す
     */
    $_moveScrollToTop: function () {
      this.$refs['place-list-inner'].scrollToPosition(0)
    },

    /**
     * プレイスグループが変更された時の処理
     * @param {number} newGroupId 新たに選択されたグループID
     */
    $_changePlaceGroup: function (newGroupId) {
      // グループが変更されていない場合は何もしない
      if (this.currentPlaceGroupId === newGroupId) {
        return
      }

      // 現在の入力中のキーワード値を反映
      this.searchKeyword = this.localKeyword

      this.currentPlaceGroupId = newGroupId
      this.showPlaceData()
    },

    /**
     * Dateオブジェクトからmomentを生成する
     * @param {Date} dateValue 元の日付
     * @return {moment} moment、ただしdateValueがnullの場合はnull
     */
    $_createMoment: function (dateValue) {
      if (!dateValue) {
        return null
      }
      return moment(dateValue)
    },

    /**
     * 検索対象期間が変更された時の処理
     * @param {string} startDate 開始日文字列(yyyy-mm-dd)
     * @param {string} startTime 開始時刻文字列(hh:mm)
     * @param {string} endDate 終了日文字列(yyyy-mm-dd)
     * @param {string} endTime 終了時刻文字列(hh:mm)
     * @param {string} errorMessage バリデーションエラーメッセージ
     */
    $_changeSearchPeriod: function (
      startDate,
      startTime,
      endDate,
      endTime,
      errorMessage
    ) {
      if (errorMessage) {
        // バリデーションエラーを表示する
        this.$alert.fire({
          icon: 'error',
          title: this.$t('thePlace.message.invalidRegistrationDate'),
          text: errorMessage,
        })
      } else {
        const newStartDate = this.$_parseDate(startDate)
        const newEndDate = this.$_parseDate(endDate)
        // 期間が変更されていない場合は何もしない
        if (
          +this.searchPeriod.startDate == +newStartDate &&
          +this.searchPeriod.endDate == +newEndDate
        ) {
          return
        }

        // 現在の入力中のキーワード値を反映
        this.searchKeyword = this.localKeyword

        // 指定された期間でプレイスを検索する
        this.searchPeriod.startDate = newStartDate
        this.searchPeriod.endDate = newEndDate
        this.showPlaceData()
      }
    },

    /**
     * 日付文字列(yyyy-mm-de)から日付オブジェクトを作成する
     * @param {string} targetDate 対象日付文字列
     * @return {Date} 生成した日付、ただしtargetDateがnullの場合はnullを返却する
     */
    $_parseDate: function (targetDate) {
      return targetDate ? moment(targetDate).toDate() : null
    },

    /**
     * 位置確定ボタンをクリックした時の処理
     */
    $_changePositionFixType: function (fixType) {
      // 変更されていない場合は何もしない
      if (this.currentPositionFixTypes === fixType) {
        return
      }
      this.currentPositionFixTypes = fixType
      this.showPlaceData()
    },

    /**
     * ユーザー選択コンポーネントで検索対象のユーザーが確定した時の処理
     * @param {Array.<Object>} retValue ユーザー/グループID, 名前の配列
     */
    $_fixSelectedUsers: function (retValue) {
      if (!retValue) {
        this.currentUserIds = []
        this.currentOrganizationIds = []
        this.showPlaceData()
        return
      }

      const selectedUserIds = retValue
        .filter((value) => value.type === 'user')
        .map((value) => value.id)
      const selectedOrganizationIds = retValue
        .filter((value) => value.type === 'organization')
        .map((value) => value.id)
      // 変更されていない場合は何もしない
      if (
        _.isEqual(this.currentUserIds, selectedUserIds) &&
        _.isEqual(this.currentOrganizationIds, selectedOrganizationIds)
      ) {
        return
      }

      // 現在の入力中のキーワード値を反映
      this.searchKeyword = this.localKeyword

      this.currentUserIds = selectedUserIds
      this.currentOrganizationIds = selectedOrganizationIds
      this.showPlaceData()
    },

    /**
     * 検索対象項目選択コンポーネントで検索対象の項目が確定した時の処理
     * @param {Array.<Object>} selectedKeywordTarget // 選択された検索項目オブジェクト
     */
    $_fixSelectedKeywordTarget: function (selectedKeywordTarget) {
      this.$store.dispatch('place/setKeywordTargets', selectedKeywordTarget)
      if (!this.searchKeyword && !this.localKeyword) return
      // 現在の入力中のキーワード値を反映
      this.searchKeyword = this.localKeyword
      // プレイスを再検索する
      this.showPlaceData()
    },

    /**
     * キーワード検索時の処理
     * @param {String} keyword 入力されたキーワード
     */
    $_changeKeyword: function (keyword) {
      // 変更されていない場合は何もしない
      if (this.searchKeyword === keyword) {
        return
      }
      this.searchKeyword = keyword
      // プレイスを再検索する
      this.showPlaceData()
    },

    /**
     * 地図の表示領域の変更が完了したときの処理
     */
    $_onBoundsChanged: async function (bounds) {
      // bounds更新
      const boundsInstance = new Bounds(bounds)
      // 同じ範囲の時は何もしない
      if (boundsInstance.equals(this.mapBounds)) {
        return
      }
      this.bounds = bounds

      if (this.toShowPlacesOnlyInBounds) {
        this.showPlaceDataDebounce()
      }
    },

    /**
     * 更新ボタンクリック時処理
     */
    $_onClickReload: function () {
      this.$_updateAllPlaces()
    },

    /**
     * 全プレイスを更新する
     */
    $_updateAllPlaces: function () {
      this.$_forceRender()
      this.showPlaceData().then(() => {
        // 更新日時を更新する
        this.listUpdatedDate = Date.now()
      })
    },

    /**
     * deck.gl強制再描画
     */
    $_forceRender: function () {
      this.deck && this.deck.render(true)
    },

    /**
     * プレイス詳細ダイアログを表示する
     * @param record 表示対象のプレイス一覧のレコードID
     */
    $_showDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['place-detail'].showModal(recordId)
    },

    /**
     * プレイス詳細ダイアログを非表示にする時の処理
     */
    $_onHideDetailDialog: function (isUpdated) {
      if (isUpdated) {
        // 更新したプレイスを反映するためにキャッシュを削除して更新
        this.$_updateAllPlaces()
      }
    },

    /**
     * プレイスカードをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardBody: function (timelineType, recordId) {
      // 地図のフォーカスを選択したデータに設定する
      const target = this.places.find((place) => place.id === recordId)
      target && this.$_fitMap([target])
    },

    /**
     * プレイスカードのタイトルをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardTitle: function (timelineType, recordId) {
      // 詳細ダイアログを表示する
      this.$_showDialog(recordId)
    },

    /**
     * プレイスカードの詳細ボタンをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardDetail: function (timelineType, recordId) {
      // 詳細ダイアログを表示する
      this.$_showDialog(recordId)
    },

    /**
     * 添付ファイル数を返却する
     * @param {Object} placeAttachFiles 添付ファイル(report.place_attach_files)
     * @return {Number} 添付ファイル数
     */
    $_getAttachFileCount: function (placeAttachFiles) {
      return placeAttachFiles ? placeAttachFiles.length : 0
    },

    /**
     * プレイスグループ名の一覧を返却する
     * @param {Array} placeGroups プレイスグループ一覧(report.place_groups)
     * @return {Array} プレイスグループ名の一覧
     */
    $_getPlaceGroupNames: function (placeGroups) {
      let placeGroupNames = new Array()
      if (placeGroups) {
        placeGroups.forEach((group) => {
          placeGroupNames.push(group.place_group_name)
        })
      }
      return placeGroupNames
    },

    /**
     * 担当者名の一覧を返却する
     * @param {Array} userRelations 担当者一覧(place.place_user_relations)
     * @return {Array} 担当者名の一覧
     */
    $_getUserRelationNames: function (userRelations) {
      let userNames = new Array()
      if (userRelations) {
        userRelations.forEach((user) => {
          userNames.push(user.user_name)
        })
      }
      return userNames
    },

    /**
     * 担当グループ名の一覧を返却する
     * @param {Array} organizationRelations 担当グループ一覧(place.place_organization_relations)
     * @return {Array} 担当グループ名(所属人数)の配列
     */
    $_getOrganizationRelationNames: function (organizationRelations) {
      let organizationNames = new Array()
      if (organizationRelations) {
        organizationRelations.forEach((organization) => {
          organizationNames.push(
            `${organization.organization_name} (${organization.organization_user_relations.length}) `
          )
        })
      }
      return organizationNames
    },

    /**
     * プレイスを新規登録する
     */
    createPlace: function () {
      this.$refs['place-editor'].showModal(0)
    },

    /**
     * プレイス作成完了時処理
     */
    $_onCreatedPlace: function () {
      // 登録したプレイスを反映するためにキャッシュを削除して更新
      this.$_updateAllPlaces()

      if (this.isLastPage && this.isCurrentPageFull) {
        // watchで更新が走る
        this.currentPlacePage += 1
        this.$nextTick(() => {
          this.$refs['pagination'].currentPage = this.currentPlacePage
          this.$refs['pagination'].focusLast()
        })
      }
    },

    /**
     * リストビューの表示・非表示を切り替える
     */
    $_toggleListViewShown: function () {
      this.isListViewShown = !this.isListViewShown
    },

    /**
     * 報告書ページへ遷移する
     * @param {Array.<Number>} placeIds プレイスID配列
     */
    $_showReport: function (placeIds) {
      this.$router.push({
        name: 'report',
        params: {
          defaultPlaceIds: placeIds,
        },
      })
    },

    /**
     * 地図ページへ遷移する
     * @param {Object} params 遷移時に引き渡すパラメータ
     */
    $_showMember: function (params) {
      this.$router.push({
        name: 'member',
        params,
      })
    },

    /**
     * モーダル重畳状態変更時処理
     * @param {Boolean} value モーダル重畳状態
     */
    $_onModalOverlayChanged: function (value) {
      this.isModalOverlaid = value
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';
@use '../assets/scss/parts/tool-bar';
@use '../assets/scss/parts/title-bar';

$-list-header-height: 52px;
$-list-footer-height: calc(
  #{$pagination-height} + #{$list-footer-padding-top} +
    #{$list-footer-border-width}
);

#the-place {
  width: 100%;
  height: 100%;
}

.container-place {
  ::v-deep .row {
    margin: 0 !important;
  }
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100% - #{$tool-bar-height});
  margin-right: 0;
}

.view-list {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
}

.view-map {
  display: -webkit-box !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 100%;
}

.tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tool-bar-form {
  width: 100%;
  .place-group-select-col {
    flex-grow: 0;
    flex-basis: 19%;
  }
  .user-select-col {
    flex-grow: 0;
    flex-basis: 18%;
  }
  .datetime-select-col {
    flex-grow: 0;
    flex-basis: 24%;
  }
}

.title-bar {
  padding: 0 10px 0 16px;
}

.title-bar-action {
  column-gap: 8px;
}

.button-create {
  @include mixin-button;
  & {
    height: $button-size;
    column-gap: 4px;
    padding: 0 8px 0 6px;
    font-size: $font-size-small;
  }
}

.list-wrapper {
  height: calc(100% - #{$title-bar-height});
  padding: 0 10px 6px 10px;
  flex-grow: 1;
  flex-basis: 0;
}

.list-header {
  height: $-list-header-height;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-inner {
  height: calc(100% - #{$-list-header-height} - #{$-list-footer-height});
  overflow-y: scroll;
  @include mixin-scrollbar;

  ::v-deep .resize-observer {
    display: none;
  }
}

.place-detail-content {
  width: 100%;
  height: 180px; // card-placeのheight 160px + 下部margin 20px
}

.list-footer {
  width: 100%;
  height: $-list-footer-height;
  padding-top: $list-footer-padding-top;
  background-color: #fff;
  border-top: $list-footer-border-width solid #eaecef;
}

.place-pagination {
  @include mixin-pagination;
}

.list-tab {
  position: absolute;
  left: 0;
  top: 16px;
}

#place-map-control {
  ::v-deep .control-wrapper {
    &.left-top-wrapper,
    &.left-bottom-wrapper {
      padding-left: 40px;
    }
    .map-control-ui {
      pointer-events: auto;
    }
  }
}
</style>
